var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 12,
    x2: 32,
    y2: 52,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 53.975,
    y1: 20.11,
    x2: 53.975,
    y2: 50,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 10.025,
    y1: 20.11,
    x2: 10.025,
    y2: 50,
    gradientUnits: "userSpaceOnUse",
    id: "color-3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 14.13,
    x2: 32,
    y2: 34.77,
    gradientUnits: "userSpaceOnUse",
    id: "color-4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,16.82h-0.01c-0.05,-2.67 -2.18,-4.82 -4.79,-4.82h-42.4c-2.61,0 -4.74,2.15 -4.79,4.82h-0.01c0,0.01 0.01,0.02 0.01,0.04c0,0.02 -0.01,0.03 -0.01,0.05v30.18c0,2.71 2.16,4.91 4.8,4.91h42.4c2.64,0 4.8,-2.2 4.8,-4.91v-30.18c0,-0.02 -0.01,-0.03 -0.01,-0.05c0,-0.02 0.01,-0.03 0.01,-0.04zM50.67,14l-18.67,13.11l-18.67,-13.11zM10.03,14.13l21.97,15.43l21.97,-15.43c1.15,0.34 2,1.42 2.02,2.72c-0.03,0.64 -0.87,1.44 -1.3,1.74l-22.69,16.18l-22.7,-16.19c-0.42,-0.29 -1.26,-1.09 -1.29,-1.73c0.02,-1.3 0.87,-2.38 2.02,-2.72zM12,23v27h-1.2c-1.54,0 -2.8,-1.31 -2.8,-2.91v-26.98c0.07,0.05 0.12,0.09 0.14,0.11l3.91,2.78zM50,50h-36v-25.61l18,12.84l18,-12.84zM56,47.09c0,1.6 -1.26,2.91 -2.8,2.91h-1.2v-27h-0.05l3.9,-2.78c0.02,-0.02 0.08,-0.06 0.15,-0.11z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,20.11v26.98c0,1.6 -1.26,2.91 -2.8,2.91h-1.2v-27h-0.05l3.9,-2.78c0.02,-0.02 0.08,-0.06 0.15,-0.11z",
    fill: "url(#color-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.05,23h-0.05v27h-1.2c-1.54,0 -2.8,-1.31 -2.8,-2.91v-26.98c0.07,0.05 0.12,0.09 0.14,0.11z",
    fill: "url(#color-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.99,16.85c-0.03,0.64 -0.87,1.44 -1.3,1.74l-22.69,16.18l-22.7,-16.19c-0.42,-0.29 -1.26,-1.09 -1.29,-1.73c0.02,-1.3 0.87,-2.38 2.02,-2.72l21.97,15.43l21.97,-15.43c1.15,0.34 2,1.42 2.02,2.72z",
    fill: "url(#color-4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail-icon.82c12b6dff8acebe533cc41ef36f56fa.svg";
export { ForwardRef as ReactComponent };